<template>
	<transition :name="transition" mode="out-in" :duration="300">
		<div
			v-if="messageContent"
			class="messageBox"
			:class="['messageBox--' + messageType]"
			@click="click"
		>
			<div class="messageBox-icon"><img :src="imgSrc"></div>
			<div class="messageBox-message">
				<slot :content="messageContent">
					{{ messageContent }}
				</slot>
			</div>
		</div>
	</transition>
</template>

<script src="./MessageBox.js"></script>
